import { css } from 'emotion';

export const hideKendoUploadElementsClass = css`
    .k-actions,
    .k-progressbar {
        display: none;
    }
    .k-dropzone-hint {
        display: none;
    }
`;

export const helperText = css`
    font-size: 12px;
    color: #5e5e5e;
    margin-top: 4px;
    text-align: right;
`;

export const DEFAULT_FILE_SIZE_LIMIT = 5;
export const MB_SIZE = 1024 * 1024;
export const DEFAULT_FILE_SIZE_LIMIT_MB = 5 * MB_SIZE;

export const SINGLE_FILE_UPLOAD = 1;
